<div class="main-table">
  <table class="table">
    <thead>
      <tr>
        <ng-container *ngFor="let tableColumn of tableColumns">
          <th [class.custom-bg-th]="tableColumn.border">
            <span class="header_label">
              {{ tableColumn?.columnName | translate }}
              <span class="text-transform-normal">
                {{ tableColumn?.symbol | reportDataValueType : current_lang }}
              </span>
            </span>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of tableData" [ngClass]="{ hideTable: showLoader }"
        [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor">
        <td>{{ element?.unit_size ?? '-' }}</td>
        <td>{{ element?.grade_a_plus ? (element.grade_a_plus | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.grade_a ? (element.grade_a | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.grade_b ? (element.grade_b | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.grade_c ? (element.grade_c | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.grade_undefined ? (element.grade_undefined | number:'1.0-1') : '-' }}</td>
      </tr>

      <tr *ngIf="showLoader" style="height: auto;">
        <td [attr.colspan]="tableColumns.length">
          <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>
</div>
